
function openModal(modalId) {
    const modal = document.getElementById(modalId)
    if(modal) {
        modal.classList.toggle('active')
    }
}


export { openModal }